import React, { useEffect, useState } from 'react';
import { API_URL } from '../config';
import { Bell, Calendar, ChevronRight, X, AlertCircle, RefreshCw, Inbox, Sparkles } from 'lucide-react';

function Duyurular() {
  const [announcements, setAnnouncements] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [activeAnnouncement, setActiveAnnouncement] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchAnnouncements();
  }, []);

  const fetchAnnouncements = async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await fetch(`${API_URL}/api/duyurular`);

      if (!response.ok) {
        throw new Error(`Sunucu hatası: ${response.status}`);
      }

      const data = await response.json();
      console.log('Gelen duyurular:', data);

      // Tarihe göre sırala (en yeni en üstte)
      const sortedData = Array.isArray(data)
        ? data.sort((a, b) => new Date(b.date) - new Date(a.date))
        : [];

      setAnnouncements(sortedData);
    } catch (error) {
      console.error('Duyurular alınırken hata oluştu:', error);
      setError(error.message || 'Duyurular yüklenirken bir hata oluştu. Lütfen daha sonra tekrar deneyin.');
    } finally {
      setLoading(false);
    }
  };

  const handleCardClick = (announcement) => {
    setActiveAnnouncement(announcement);
    setShowModal(true);
    document.body.style.overflow = 'hidden';
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setActiveAnnouncement(null);
    document.body.style.overflow = 'unset';
  };

  useEffect(() => {
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  // Yıldız animasyonlu arkaplan
  const starryBackground = {
    backgroundImage: `
      radial-gradient(2px 2px at 20px 30px, rgba(255,255,255,0.8), transparent),
      radial-gradient(2px 2px at 60px 70px, rgba(255,255,255,0.6), transparent),
      radial-gradient(1px 1px at 50px 50px, rgba(255,255,255,0.4), transparent),
      radial-gradient(1px 1px at 130px 80px, rgba(255,255,255,0.5), transparent),
      radial-gradient(2px 2px at 90px 10px, rgba(255,255,255,0.7), transparent),
      radial-gradient(1.5px 1.5px at 180px 120px, rgba(255,255,255,0.6), transparent),
      radial-gradient(1px 1px at 200px 180px, rgba(255,255,255,0.4), transparent),
      radial-gradient(2px 2px at 250px 50px, rgba(255,255,255,0.8), transparent)
    `,
    backgroundSize: '200px 200px, 300px 300px, 400px 400px, 250px 250px, 350px 350px, 280px 280px, 320px 320px, 380px 380px',
    animation: 'starAnimation 60s linear infinite'
  };

  if (loading) {
    return (
      <div 
        className="min-h-screen bg-gradient-to-b from-slate-900 via-blue-950 to-slate-900 py-12 px-5 relative overflow-hidden"
        style={starryBackground}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-blue-900/10 to-transparent pointer-events-none" />
        
        <div className="relative z-10 max-w-7xl mx-auto pt-16">
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-3 mb-4">
              <Bell className="w-10 h-10 text-blue-400" />
              <h1 className="text-5xl md:text-6xl font-bold text-white tracking-tight">
                Duyurular
              </h1>
            </div>
            <p className="text-blue-200/60 text-lg">ACM Iğdır'dan en güncel haberler</p>
          </div>
          
          <div className="flex flex-col items-center justify-center py-20">
            <div className="relative">
              <div className="w-16 h-16 border-4 border-blue-500/30 border-t-blue-400 rounded-full animate-spin" />
              <Sparkles className="absolute inset-0 m-auto w-6 h-6 text-blue-400 animate-pulse" />
            </div>
            <p className="mt-6 text-blue-200/80 text-lg font-medium">Duyurular yükleniyor...</p>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div 
        className="min-h-screen bg-gradient-to-b from-slate-900 via-blue-950 to-slate-900 py-12 px-5 relative overflow-hidden"
        style={starryBackground}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-blue-900/10 to-transparent pointer-events-none" />
        
        <div className="relative z-10 max-w-7xl mx-auto pt-16">
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-3 mb-4">
              <Bell className="w-10 h-10 text-blue-400" />
              <h1 className="text-5xl md:text-6xl font-bold text-white tracking-tight">
                Duyurular
              </h1>
            </div>
            <p className="text-blue-200/60 text-lg">ACM Iğdır'dan en güncel haberler</p>
          </div>
          
          <div className="max-w-md mx-auto">
            <div className="bg-gradient-to-br from-red-500/10 to-red-600/5 backdrop-blur-xl border border-red-500/20 rounded-2xl p-8 text-center">
              <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-red-500/20 flex items-center justify-center">
                <AlertCircle className="w-8 h-8 text-red-400" />
              </div>
              <h3 className="text-xl font-semibold text-white mb-2">Bir Hata Oluştu</h3>
              <p className="text-red-200/80 mb-6">{error}</p>
              <button
                onClick={fetchAnnouncements}
                className="inline-flex items-center gap-2 bg-red-500 hover:bg-red-600 text-white px-6 py-3 rounded-xl font-medium transition-all hover:scale-105"
              >
                <RefreshCw className="w-4 h-4" />
                Tekrar Dene
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div 
      className="min-h-screen bg-gradient-to-b from-slate-900 via-blue-950 to-slate-900 py-12 px-5 relative overflow-hidden"
      style={starryBackground}
    >
      {/* Dekoratif gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-blue-900/10 to-transparent pointer-events-none" />
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-purple-500/10 rounded-full blur-3xl pointer-events-none" />
      
      <div className="relative z-10 max-w-7xl mx-auto pt-16">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-3 mb-4">
            <div className="p-3 bg-blue-500/20 rounded-2xl backdrop-blur-sm border border-blue-500/30">
              <Bell className="w-8 h-8 text-blue-400" />
            </div>
            <h1 className="text-5xl md:text-6xl font-bold text-white tracking-tight">
              Duyurular
            </h1>
          </div>
          <p className="text-blue-200/60 text-lg max-w-2xl mx-auto">
            ACM Iğdır'dan en güncel haberler, etkinlikler ve duyurular
          </p>
          <div className="mt-4 inline-flex items-center gap-2 px-4 py-2 bg-blue-500/10 rounded-full border border-blue-500/20">
            <span className="w-2 h-2 bg-green-400 rounded-full animate-pulse" />
            <span className="text-blue-200/80 text-sm">{announcements.length} aktif duyuru</span>
          </div>
        </div>

        {/* Duyuru Kartları */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {announcements.length > 0 ? (
            announcements.map((announcement, index) => (
              <div
                key={announcement.id || announcement._id}
                className="group relative bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-xl rounded-2xl border border-white/10 overflow-hidden cursor-pointer transition-all duration-500 hover:scale-[1.02] hover:border-blue-500/30 hover:shadow-2xl hover:shadow-blue-500/10"
                onClick={() => handleCardClick(announcement)}
                style={{ animationDelay: `${index * 100}ms` }}
              >
                {/* Hover glow efekti */}
                <div className="absolute inset-0 bg-gradient-to-br from-blue-500/0 to-purple-500/0 group-hover:from-blue-500/5 group-hover:to-purple-500/5 transition-all duration-500" />
                
                {/* Görsel */}
                <div className="relative h-48 overflow-hidden">
                  {announcement.cardImage ? (
                    <img
                      src={announcement.cardImage}
                      alt={announcement.title}
                      className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.style.display = 'none';
                        e.target.nextSibling.style.display = 'flex';
                      }}
                    />
                  ) : null}
                  <div className={`absolute inset-0 bg-gradient-to-br from-blue-600/30 to-purple-600/30 ${announcement.cardImage ? 'hidden' : 'flex'} items-center justify-center`}>
                    <Bell className="w-16 h-16 text-white/40" />
                  </div>
                  {/* Gradient overlay */}
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-900/90 via-slate-900/20 to-transparent" />
                  
                  {/* Tarih badge */}
                  <div className="absolute top-4 right-4 px-3 py-1.5 bg-black/40 backdrop-blur-md rounded-lg border border-white/10">
                    <div className="flex items-center gap-1.5 text-white/90 text-xs font-medium">
                      <Calendar className="w-3.5 h-3.5" />
                      {new Date(announcement.date).toLocaleDateString('tr-TR', {
                        day: 'numeric',
                        month: 'short'
                      })}
                    </div>
                  </div>
                </div>

                {/* İçerik */}
                <div className="relative p-6">
                  <h2 className="text-xl font-bold text-white mb-3 line-clamp-2 group-hover:text-blue-300 transition-colors">
                    {announcement.title}
                  </h2>
                  <p className="text-blue-100/60 text-sm line-clamp-3 mb-4 leading-relaxed">
                    {announcement.shortDetail}
                  </p>
                  
                  <div className="flex items-center justify-between">
                    <span className="text-xs text-blue-200/40">
                      {new Date(announcement.date).toLocaleDateString('tr-TR', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric'
                      })}
                    </span>
                    <div className="flex items-center gap-1 text-blue-400 text-sm font-medium group-hover:gap-2 transition-all">
                      <span>Detaylar</span>
                      <ChevronRight className="w-4 h-4" />
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="col-span-full">
              <div className="max-w-md mx-auto bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-xl rounded-2xl border border-white/10 p-12 text-center">
                <div className="w-20 h-20 mx-auto mb-6 rounded-2xl bg-blue-500/20 flex items-center justify-center">
                  <Inbox className="w-10 h-10 text-blue-400" />
                </div>
                <h3 className="text-2xl font-bold text-white mb-3">Henüz Duyuru Yok</h3>
                <p className="text-blue-200/60">
                  Yeni duyurular eklendiğinde burada görünecek. Bizi takip etmeye devam edin!
                </p>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Modal */}
      {showModal && activeAnnouncement && (
        <div
          className="fixed inset-0 bg-black/80 backdrop-blur-md flex items-center justify-center z-50 p-4"
          onClick={handleCloseModal}
          style={{ animation: 'fadeIn 0.3s ease-out' }}
        >
          <div
            className="bg-gradient-to-br from-slate-800 to-slate-900 rounded-3xl max-w-4xl w-full max-h-[90vh] overflow-hidden relative border border-white/10 shadow-2xl"
            onClick={(e) => e.stopPropagation()}
            style={{ animation: 'slideInUp 0.4s ease-out' }}
          >
            {/* Close button */}
            <button
              className="absolute top-4 right-4 z-20 w-10 h-10 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 text-white/80 hover:text-white transition-all backdrop-blur-sm border border-white/10"
              onClick={handleCloseModal}
              aria-label="Kapat"
            >
              <X className="w-5 h-5" />
            </button>

            <div className="max-h-[90vh] overflow-y-auto">
              {/* Modal Image */}
              {activeAnnouncement.modalImage && (
                <div className="relative h-64 md:h-80">
                  <img
                    src={activeAnnouncement.modalImage}
                    alt={activeAnnouncement.title}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      e.target.style.display = 'none';
                    }}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/50 to-transparent" />
                </div>
              )}

              {/* Modal Content */}
              <div className={`p-8 md:p-10 ${activeAnnouncement.modalImage ? '-mt-20 relative z-10' : ''}`}>
                <div className="flex items-center gap-3 mb-4">
                  <div className="px-3 py-1.5 bg-blue-500/20 rounded-lg border border-blue-500/30 inline-flex items-center gap-2">
                    <Calendar className="w-4 h-4 text-blue-400" />
                    <span className="text-blue-300 text-sm font-medium">
                      {new Date(activeAnnouncement.date).toLocaleDateString('tr-TR', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric',
                        weekday: 'long'
                      })}
                    </span>
                  </div>
                </div>

                <h2 className="text-3xl md:text-4xl font-bold text-white mb-6 leading-tight">
                  {activeAnnouncement.title}
                </h2>

                <div className="prose prose-lg prose-invert max-w-none">
                  <p className="text-blue-100/80 text-lg leading-relaxed whitespace-pre-line">
                    {activeAnnouncement.modalDetail}
                  </p>
                </div>

                {/* Footer */}
                <div className="mt-8 pt-6 border-t border-white/10 flex items-center justify-between">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-full bg-blue-500/20 flex items-center justify-center">
                      <Bell className="w-5 h-5 text-blue-400" />
                    </div>
                    <div>
                      <p className="text-white font-medium text-sm">ACM Iğdır</p>
                      <p className="text-blue-200/50 text-xs">Resmi Duyuru</p>
                    </div>
                  </div>
                  <button
                    onClick={handleCloseModal}
                    className="px-6 py-2.5 bg-white/10 hover:bg-white/20 text-white rounded-xl font-medium transition-all border border-white/10"
                  >
                    Kapat
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Duyurular;
